import {GraphDataType} from "./graph-data-type";

export const graphDataTypes: GraphDataType[] = [
    { key: "temperature", label: "Teplota", unit: "°C" },
    { key: "humidity", label: "Relativní vlhkost vzduchu", unit: "%" },
    { key: "wind", label: "Rychlost větru", unit: "m/s" },
]
